import { AccountingResult, AuditDetails, ContactSummary, Entity, EntityLink, Invoice, InvoiceContact, InvoiceType, PaymentSource } from '../';

export interface FinancialAllocation {

    contact: Entity; // customer 
    company: Entity; // billing company

    amount: number;
    date: Date;

    integration?: AccountingResult;
    source: PaymentSource;
}

export interface InvoiceAllocation extends Entity, AuditDetails, FinancialAllocation {

    fromInvoice: EntityLink; // PP or CR
    toInvoice: EntityLink; // Normal Invoice

}

export interface BillAllocation extends Entity, AuditDetails, FinancialAllocation {

    fromBill: EntityLink; // PP or CR
    toBill: EntityLink; // Normal Bill

}

export interface InvoiceSummaryForAllocation extends Pick<
    Invoice,
    '_id' | 'invoiceNumber' | 'invoiceDate' | 'type' | 'total' |
    'prepaymentTotal' | 'outstandingAmount' | 'amountPaid' | 'creditAmount' |
    'updatedAt' | 'dueDate'
> {

    amountToCredit: number;
}

export interface BillSummaryForAllocation extends InvoiceSummaryForAllocation {

}

// show credit info of all type of invoice
export type InvoiceCreditInfo = {
    customerName: string;
    amount: number;
}

export type BillCreditInfo = {
    accountName: string;
    amount: number;
}

// #region Allocate Credit

export enum AllocateCreditSourceAction {
    AllocateFrom = 'Allocate From',
    AllocateTo = 'Allocate To',
}

export interface AllocateCreditResponseResult {

    success: boolean;
    message: string;
}

export interface AllocateCreditRequest {

    invSource: InvoiceSummaryForAllocation;
    invDestinations: Array<InvoiceSummaryForAllocation>;

    invSrcAction: AllocateCreditSourceAction;
}

export interface AllocateCreditResponse extends AllocateCreditResponseResult {
    addedAllocations: InvoiceAllocation[];
    listUpdatedInvoiceId: string[];
}

export interface BillAllocateCreditRequest {

    billSource: BillSummaryForAllocation;
    billDestinations: Array<BillSummaryForAllocation>;

    billSrcAction: AllocateCreditSourceAction;
}

export interface BillAllocateCreditResponse extends AllocateCreditResponseResult {
    addedAllocations: BillAllocation[];
    listUpdatedBillId: string[];
}

// #endregion


// #region Remove allocation

export interface RemoveCreditAllocationRequest {
    allocationId: string;
}

export interface RemoveCreditAllocationResponse extends AllocateCreditResponseResult {
    removedAllocation: InvoiceAllocation;
    listUpdatedInvoiceId: string[];
}


export interface RemoveBillAllocationResponse extends AllocateCreditResponseResult {
    removedAllocation: BillAllocation;
    listUpdatedBillId: string[];
}

// #endregion


export interface CreditAllocationSyncRequest {
    allocationId: string;

    fromInvoiceType?: InvoiceType;
    toInvoiceContactId: string;

    fromInvoiceId?: string;
    toInvoiceId?: string;

    fromInvoiceIntegrationId?: string;
    toInvoiceIntegrationId?: string;

    date: Date;
    amount: number;

    toInvoiceContact: InvoiceContact;
}